
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { JobDetail, Image, Company, Worker, Conversation } from '@/@types/LibraryComponent';

@Component
export default class Member extends Vue {
  @Prop()
  private job!: JobDetail;
  private tab: string = '';
  private worker1: string = require('../../assets/worker1.jpg');
  private worker2: string = require('../../assets/worker2.jpg');
  private worker3: string = require('../../assets/worker3.jpg');
  private worker4: string = require('../../assets/worker4.jpg');

  // TODO: require引数に変数を設定できないので暫定対応(画像取得方法は変わるはずのため不要になるはず)
  private portrait(portrait: string) {
    if (portrait.includes('worker1')) {
      return this.worker1;
    } else if (portrait.includes('worker2')) {
      return this.worker2;
    } else if (portrait.includes('worker3')) {
      return this.worker3;
    } else if (portrait.includes('worker4')) {
      return this.worker4;
    }
  }
}
